import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { GUIDES } from "../lib/guides";
import Seo, { SITE_ORIGIN } from "../components/Seo";

const guidesJsonLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: GUIDES.map((g, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${SITE_ORIGIN}/guides/${g.slug}`,
    name: g.title,
  })),
};

export default function Guides() {
  return (
    <div className="min-h-screen bg-[#05060f] text-white px-6 py-16">
      <Seo
        title="CardArk Guides — Pokemon Card Values, Rarity, Grading & Selling Tips"
        description="Free, practical guides on valuing Pokemon cards, spotting rares and fakes, grading (PSA vs CGC vs Beckett), selling your collection, and scanning cards with video."
        path="/guides"
        jsonLd={guidesJsonLd}
      />
      <div className="max-w-4xl mx-auto">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#A78BFA] border border-[#A78BFA]/30 rounded-full px-4 py-1.5 bg-[#A78BFA]/5 mb-6">
          <BookOpen className="w-3 h-3" /> Guides
        </span>
        <h1 className="font-display text-3xl md:text-4xl font-bold mb-3">Get more out of every scan</h1>
        <p className="text-zinc-400 mb-12 max-w-2xl text-sm md:text-base">
          Practical, no-fluff guides on scanning cards with video, grading condition honestly, and building a
          collection you actually know inside out.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {GUIDES.map((guide, i) => (
            <Link
              key={guide.slug}
              to={`/guides/${guide.slug}`}
              data-testid={`guide-card-${guide.slug}`}
              className="group border border-white/10 bg-[#111113] rounded-2xl p-6 flex flex-col hover:-translate-y-1 hover:border-[#A78BFA]/40 transition-transform duration-300 animate-fade-up"
              style={{ animationDelay: `${i * 60}ms`, opacity: 0 }}
            >
              <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-zinc-500 mb-3">
                <span className="px-2 py-0.5 rounded-full border border-[#A78BFA]/30 bg-[#A78BFA]/10 text-[#A78BFA]">{guide.category}</span>
                <span>{guide.readTime}</span>
              </div>
              <h2 className="font-display font-semibold text-lg leading-snug mb-2 group-hover:text-[#A78BFA] transition-colors">
                {guide.title}
              </h2>
              <p className="text-sm text-zinc-400 flex-1">{guide.description}</p>
              <span className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-[#A78BFA]">
                Read guide <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
